import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ShowcaseFilterEntity } from '../../domain/entities/ShowcaseFilterEntity'
import type { ShowcaseModeType } from '../../domain/enums/ShowcaseModeType'

export class ShowcaseFilterModel extends ShowcaseFilterEntity {
    channelId?: number
    branchId?: number
    itemId?: number 
    ignoreChannelOption?: boolean=true
    modeType?: ShowcaseModeType
    
    constructor(dataDto: ShowcaseFilterEntity) {
    super()
    mapEntityProperties<ShowcaseFilterModel>(this, dataDto, {
      exclude: ['channel', 'branch', 'item', 'mode'],
      map: { 
        modeType: dataDto.mode,
        channelId: dataDto.channel?.id,
        branchId: dataDto.branch?.id,
        itemId: dataDto.item?.id,
        ignoreChannelOption: dataDto.channel ? false : true
      }
    })
  }
}
